import React, { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'domkit/appendVendorPrefix';
import insertKeyframesRule from 'domkit/insertKeyframesRule';

/**
 * @type {Object}
 */
const keyframes = {
    '0%': {
        transform: 'scale(1)',
        opacity: 1,
    },
    '45%': {
        transform: 'scale(0.1)',
        opacity: 0.7,
    },
    '80%': {
        transform: 'scale(1)',
        opacity: 1,
    },
};

/**
 * @type {String}
 */
const animationName = insertKeyframesRule(keyframes);

const propTypes = {
    loading: PropTypes.bool,
    color: PropTypes.string,
    size: PropTypes.string,
    margin: PropTypes.string,
    id: PropTypes.string,
    className: PropTypes.string,
    verticalAlign: PropTypes.string,
};

const defaultProps = {
    loading: true,
    color: '#ffffff',
    size: '15px',
    margin: '2px',
    id: null,
    className: null,
    verticalAlign: null,
};

class Loader extends Component {
    /**
     * @return {Object}
     */
    getBallStyle() {
        return {
            backgroundColor: this.props.color,
            width: this.props.size,
            height: this.props.size,
            margin: this.props.margin,
            borderRadius: '100%',
            verticalAlign: this.props.verticalAlign,
        };
    }

    /**
     * @param  {Number} i
     * @return {Object}
     */
    // eslint-disable-next-line class-methods-use-this
    getAnimationStyle(i) {
        const animation = [
            animationName,
            '0.75s',
            `${(i * 0.12)}s`,
            'infinite', 'cubic-bezier(.2,.68,.18,1.08)',
        ].join(' ');
        const animationFillMode = 'both';

        return {
            animation,
            animationFillMode,
        };
    }

    /**
     * @param  {Number} i
     * @return {Object}
     */
    getStyle(i) {
        return assign(
            this.getBallStyle(i),
            this.getAnimationStyle(i),
            {
                display: 'inline-block',
            },
        );
    }

    /**
     * @param  {Boolean} loading
     * @return {ReactComponent || null}
     */
    renderLoader(loading) {
        if (loading) {
            return (
                <div id={this.props.id} className={this.props.className}>
                    <div style={this.getStyle(1)} />
                    <div style={this.getStyle(2)} />
                    <div style={this.getStyle(3)} />
                </div>
            );
        }

        return null;
    }

    render() {
        return this.renderLoader(this.props.loading);
    }
}

Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;

export default Loader;



// WEBPACK FOOTER //
// ./js/components/partials/PulseLoader.jsx